import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TankService } from 'src/app/services/tank.service';
import { UserService } from 'src/app/services/user.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { VoucherService } from 'src/app/services/voucher.service';
import { User } from 'src/app/shared/models/User';
import { Vehicle } from 'src/app/shared/models/Vehicle';
import { Voucher } from 'src/app/shared/models/Voucher';
import { DatepickerRangeComponent } from '../../partials/datepicker-range/datepicker-range.component';

@Component({
  selector: 'app-print-voucher-page',
  templateUrl: './print-voucher-page.component.html',
  styleUrls: ['./print-voucher-page.component.css']
})
export class PrintVoucherPageComponent implements OnInit {

  @ViewChild(DatepickerRangeComponent) datepickerRangeComponent: DatepickerRangeComponent;

  voucherForm: FormGroup;
  titulo = 'Crear Voucher para: ';
  tankName: string;
  tankId: number;
  id: number;


  operatorList: User[] = [];
  selectedOperator: User;
  operatorSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false
  };


  vehicleList: Vehicle[] = [];
  selectedVehicle: Vehicle;
  vehicleSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false
  };



  constructor(private fb: FormBuilder, private router: Router, private activatedRoute: ActivatedRoute, private voucherService: VoucherService,
    private _tankService: TankService, private userService: UserService, private vehicleService: VehicleService) {
    this.voucherForm = this.initVoucherForm();
    this.id = parseInt(this.activatedRoute.snapshot.paramMap.get('id'), 10);
  }

  ngOnInit() {
    this.initializeEditMode();

  }

  saveVoucher() {
    if (this.voucherForm.invalid) {
      return;
    }

    const voucher: Voucher = this.voucherForm.value;
    voucher.tankId = this.tankId;

    voucher.initDate = this.datepickerRangeComponent.getSelectedDates().fromDate;
    voucher.expirationDate = this.datepickerRangeComponent.getSelectedDates().toDate;
    voucher.operator_name = voucher.operator[0].name;
    voucher.operator = voucher.operator[0].id;
    console.log("operador", voucher.operator)
    console.log("operador_name", voucher.operator_name)

    voucher.vehicle = voucher.vehicle[0].id;
    voucher.available = voucher.amount;

    const now = new Date();

    if (voucher.expirationDate <= now) {
      voucher.status = "EXPIRED";
    } else if (voucher.initDate <= now) {
      voucher.status = "ACTIVE";
    } else {
      voucher.status = "PENDING";
    }

    const saveOrUpdate = this.id
      ? this.voucherService.editVoucher(this.id, voucher)
      : this.voucherService.saveVoucher(voucher);

    saveOrUpdate.subscribe(
      () => this.router.navigate(['/vouchers']),
      (error) => {
        console.log(error);
        this.voucherForm.reset();
      }
    );
  }

  private initVoucherForm(): FormGroup {

    this._tankService.getCurrentTank().subscribe((tank) => {
      this.tankName = tank.name;
      this.tankId = tank.id;
      this.UpdateLists();
    });


    return this.fb.group({
      tankId: [''],
      description: ['', Validators.required],
      initDate: [''],
      expirationDate: [''],
      amount: ['', Validators.required],
      available: [''],
      status: [''],
      operator_name: [''],
      operator: ['', Validators.required],
      vehicle: ['', Validators.required],
    });
  }

  private initializeEditMode() {
    if (this.id) {
      this.titulo = 'Editar Voucher para: ';
      this.voucherService.getVoucher(this.id).subscribe((data) => {
        this.voucherForm.patchValue(data);
        console.log('vehiculo_id: ', data.vehicle)
        //this.selectedVehicle = data.vehicle;
        //this.selectedOperator = data.operator;

      });

    }
  }

  private UpdateLists() {

    this.userService.getOperatorsByTank(this.tankId).subscribe((operatorList: User[]) => {
      this.operatorList = operatorList;
      this.selectedOperator = new User;
    });

    this.vehicleService.getVehicleByTank(this.tankId).subscribe((vehicleList: Vehicle[]) => {
      this.vehicleList = vehicleList;
      this.selectedVehicle = new Vehicle;
    });
  }

}
